// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2ONuN","item":"PaymentsMobile_item__dRUGh","label":"PaymentsMobile_label__gJQxm","amount":"PaymentsMobile_amount__1tpZZ"};